import React from 'react';
import './CoordinateSystemIcon.css';

const CoordinateSystemIcon = ({ mode = 'endzone' }) => {
  const label = mode === 'matrix' ? 'M' : 'E';
  return (
    <span className={`coord-icon coord-icon--${mode}`} aria-label="Toggle coordinate system">
      {label}
    </span>
  );
};

export default CoordinateSystemIcon;
